import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './acciones.css';
import Swal from 'sweetalert2';
import ReactDOM from 'react-dom';

class Acciones extends Component {
  constructor(props) {
    super(props);
    this.state = {redirect: false, url: '', menuAbierto: false, menuPos: { top: 0, left: 0 }};
    this.redirect = this.redirect.bind(this);
    this.eliminar = this.eliminar.bind(this);
    this.desactivar = this.desactivar.bind(this);
    this.editar = this.editar.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this); 
    this.btnRef = React.createRef();
    this.menuRef = React.createRef();
  }
  redirect(url) {
    return () => {
      this.setState({url});
      this.setState({redirect: true});
    };
  }


  eliminar(id) {
    return () => {
      Swal({
        title: '¿Eliminar?',
        text: '¡No podrá revertir esta acción!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '¡Sí, eliminar!',
        cancelButtonText: 'No, cancelar',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.props.eliminar(id);
        }
      });
    }
  }

  descontinuar(id) {
    return () => mostrarSwalDescontinuar(() => this.props.descontinuarProducto(id));
  }

  reactivar(id) {
    return () => mostrarSwalReactivar(() => this.props.reactivarProducto(id));
  }

  desactivar(id) {
        return () => {
            Swal({
                title: "¿Desactivar?",
                text: "¡No podrá revertir esta acción!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "¡Sí, desactivar!",
                cancelButtonText: "No, cancelar",
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.props.desactivar(id);
                  
                }
            });
        }
    }

    anular(id) {
        return () => {
            Swal({
                title: "¿Anular?",
                text: "Ingresa el motivo de la anulación",
                input: "textarea",
                inputAttributes: {
                    autocapitalize: "off"
                },
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "¡Sí, anular!",
                cancelButtonText: "No, cancelar",
                reverseButtons: true,
                preConfirm: (txtMotivo) => {
                    if (!txtMotivo) {
                        Swal.showValidationError(
                            "Campo requerido"
                        )
                    }

                }
            }).then((result) => {
                if (result.value) {
                    const motivo = result.value;
                    this.props.anular(id, motivo);
                }
            });
        }
    }

  editar(id) {
    return () => {
     this.props.editar(id);
    }
  }

toggleMenu = (e) => {
  e.stopPropagation();
  if (this.btnRef.current && this.props.abrirMenu) {
    const rect = this.btnRef.current.getBoundingClientRect();
    this.setState({
      menuPos: {
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      },
       menuVisible: true
    }, () => {
      this.props.abrirMenu(this.props.id);
    });
  }
};

componentDidMount() {
  document.addEventListener("click", this.handleClickOutside);
}

componentWillUnmount() {
  document.removeEventListener("click", this.handleClickOutside);
}

handleClickOutside = (event) => {
  if (
    this.state.menuVisible &&
    this.menuRef.current &&
    !this.menuRef.current.contains(event.target) &&
    this.btnRef.current &&
    !this.btnRef.current.contains(event.target)
  ) {
    this.setState({ menuVisible: false });
  }
};


  render() {
    const { id, ver, editar, editar_activo, eliminar, desactivar, adicional, anular, anular_activo, id_ver, id_adicional, datos_adicional , modoMenu, descontinuarProducto } = this.props;


    if (this.state.redirect){
      return (<Redirect to={`${this.state.url}/${id}`} />);
    }
    let offset = 0;
    if (ver !== undefined){
      offset += 1;
    }
    if (editar !== undefined){
      offset += 1;
    }
    if (eliminar !== undefined){
      offset += 1;
    }
    if (desactivar !== undefined){
      offset += 1;
    }

     // -------------------------------
    // NUEVO MODO MENU DE TRES PUNTOS
    // -------------------------------
 if (modoMenu) {
      const listaFija = [
        editar && {
          render: editar_activo !== false
            ? (typeof editar === "string"
                ? <Link to={`${editar}/${id}/`}>Editar</Link>
                : <button onClick={this.editar(id)}>Editar</button>)
            : <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>Editar</span>
        },
        ver && {
          render: <Link to={`${ver}/${id_ver ? id_ver : id}/`}>Ver detalle</Link>
        },
        adicional && {
          render: (
            <Link to={`/productos/imprimir_codigos/${id_adicional ? id_adicional : id}/`}>
              Imprimir código
            </Link>
          )
        },
        descontinuarProducto && {
          render: (function() {
            if (this.props.descontinuado) {
              return (
                <span
                  onClick={this.reactivar(id)}
                  style={{ cursor: 'pointer' }}
                >
                  Reactivar producto
                </span>
              );
            } else {
              return (
                <span
                  onClick={this.descontinuar(id)}
                  style={{ cursor: 'pointer' }}
                >
                  Descontinuar producto
                </span>
              );
            }
          }.bind(this))()
        },
        eliminar && {
          render: <span onClick={this.eliminar(id)} style={{ cursor: 'pointer'}}>Eliminar</span>
        },


      ].filter(Boolean);

      return (
  <div className="acciones-menu">
    <button
      className="btn-tres-puntos"
      onClick={(e) => this.toggleMenu(e)}
      ref={this.btnRef}
    >
      ⋯
    </button>

{this.props.menuAbiertoId === this.props.id && this.state.menuVisible &&
  ReactDOM.createPortal(
    <div
      ref={this.menuRef}
      className="menu-desplegable"
      style={{
        position: "absolute",
        top: this.state.menuPos.top,
        left: this.state.menuPos.left,
        zIndex: 9999
      }}
    >
      {listaFija.map((accion, idx) => (
        <div key={idx} className="item-menu">
          {accion.render}
        </div>
      ))}
    </div>,
    document.getElementById("modal-root")
  )
}
  </div>
);
}



    return (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          {(adicional !== undefined) && adicional(id_adicional ? id_adicional : id, datos_adicional ? datos_adicional:null) }
          {(ver !== undefined) && (
            <Link to={`${ver}/${ id_ver ? id_ver : id}/`} ><img className="action-img" title="Ver" src={require("../../../../../assets/img/icons/ver.png")} alt="Ver"/></Link>
          )}
          {(editar !== undefined) && ((typeof editar) === "string") && (
              <span>
                    {
                        editar_activo !== false ? (
                            <Link to={`${editar}/${id}/`} ><img className="action-img" title="Editar" src={require("../../../../../assets/img/icons/editar.png")} alt="Editar"/></Link>
                        ): (
                            <img className="action-img" style={{ opacity:'0.5', cursor:'not-allowed'}} title="Editar" src={require("../../../../../assets/img/icons/editar.png")} alt="Editar"/>
                        )
                    }
              </span>
          )}
          {(editar !== undefined) && ((typeof editar) !== "string") && (
            <img onClick={this.editar(id)} className="action-img" title="Editar" src={require("../../../../../assets/img/icons/editar.png")} alt="Editar"/>
          )}
          {(eliminar !== undefined) && (
            <img onClick={this.eliminar(id)} className="action-img" title="Eliminar" src={require("../../../../../assets/img/icons/eliminar.png")} alt="Eliminar"/>
          )}
          {(desactivar !== undefined) && (
            <img onClick={this.desactivar(id)} className="action-img" title="Desactivar" src={require("../../../../../assets/img/icons/eliminar.png")} alt="Desactivar"/>
          )}
          {(anular !== undefined) && (
              <span>
                  {
                      anular_activo !== false ? (
                          <img onClick={this.anular(id)} className="action-img" style={{width: '20px'}} title="Anular" src={require("../../../../../assets/img/icons/anular.png")} alt="Anular"/>
                      ):(
                        <img className="action-img" style={{width: '20px', opacity:'0.5', cursor:'not-allowed'}} title="Anular" src={require("../../../../../assets/img/icons/anular.png")} alt="Anular"/>
                      )
                  }
              </span>
          )}
        </div>
      </div>
    );
  }
}
Acciones.propTypes = {
};

export function activeFormatter(acciones) {
  return (cell, row) => {
    return ( <Acciones id={cell} {...acciones}/> )
  };
}

export const mostrarSwalDescontinuar = (onConfirm) => {
  Swal({
    showCloseButton: true,
    confirmButtonText: 'Sí, deseo continuar',
    reverseButtons: true,
    html: `
      <div class="mi-swal-descontinuar">
        <div class="swal2-header-custom">
          <span>Advertencia</span>
          <div class="swal2-header-line"></div>
        </div>
        <div class="swal2-icon-custom-warning">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L1 21H23L12 2Z" stroke="#ff0000" stroke-width="2" fill="none"/>
            <path d="M12 16V18" stroke="#ff0000" stroke-width="2" stroke-linecap="round"/>
            <path d="M12 10V14" stroke="#ff0000" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <p class="swal2-content">
          ¿Estás seguro de descontinuar este producto aunque aún tiene existencias?
        </p>
        <p style="font-size: 0.9em; color: #555;">
          Si continúas, el producto no podrá ser usado en operaciones.<br>
          Puedes reactivarlo en cualquier momento si lo necesitas.
        </p>
      </div>
    `
  }).then((result) => {
    if (result.value) onConfirm();
  });
};


export const mostrarSwalReactivar = (onConfirm) => {
  Swal({
    showCloseButton: true,
    confirmButtonText: 'Sí, reactivar',
    reverseButtons: true,
    html: `
      <div class="mi-swal-descontinuar">
        <div class="swal2-header-custom">
          <span>Reactivar producto</span>
          <div class="swal2-header-line"></div>
        </div>

        <div class="swal2-icon-custom-success">
          <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#28a745" stroke-width="2" fill="none"/>
            <path d="M8 12L11 15L16 9" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <p class="swal2-content">
          ¿Deseas reactivar este producto?
        </p>
        <p style="font-size: 0.9em; color: #555;">
          El producto volverá a estar disponible en ventas e inventarios.
        </p>
      </div>
    `
  }).then((result) => {
    if (result.value) onConfirm();
  });
};